import Axios from "axios";

import { shipvistaApiV2URL } from "@/utils/constants";

/**
 * Axios client for the v2 backend (`/v2/...`, RFC 7807 problem+json, camelCase).
 * Base URL is build-time env (`NEXT_PUBLIC_API_V2_URL`) — never hardcode the host.
 * Shared by every v2 pre-login auth call (login/MFA — NEXT-01; register/verify/reset — NEXT-02).
 */
const shipvistaAPIv2 = Axios.create({
  baseURL: shipvistaApiV2URL,
  headers: { "Content-Type": "application/json" },
});

export default shipvistaAPIv2;
